module.exports = __webpack_public_path__ + "img/ky9.fe617df0.png";